import { useMutation } from "@tanstack/react-query";
import { triggerNotification } from "components/TheComponents/Notification";
import { useAppContext } from "contexts";
import { getErrorMessageFromResponse } from "helpers/apiHelpers";
import { IReward } from "components/ScreenComponent/StartEarningRewardsComponent/StartEarningRewardsComponent";

export function useChangeOrderSiteRewardMutation() {
  const { apiService } = useAppContext();

  return useMutation({
    mutationFn: async ({ items, skip }: { items: IReward[]; skip: number }) => {
      const response = await apiService.post("/site-rewards/change-order", {
        items: items.map((item, index) => ({
          id: item.id,
          order: index + 1 + skip,
        })),
      });
      return response;
    },
    onError: (error) => {
      triggerNotification({ type: "error", text: getErrorMessageFromResponse(error) });
    },
  });
}
